import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetV1PerpetualFollowsCopyTradeContractParams,
  TGetV1PerpetualFollowsCopyTradeContractResponse,
  getV1PerpetualFollowsCopyTradeContract,
  TPutV1PerpetualFollowsCopyTradeSettingParams,
  TPutV1PerpetualFollowsCopyTradeSettingResponse,
  putV1PerpetualFollowsCopyTradeSetting,
  TGetV1PerpetualFollowsCurrentCopyTradeCollectParams,
  TGetV1PerpetualFollowsCurrentCopyTradeCollectResponse,
  getV1PerpetualFollowsCurrentCopyTradeCollect,
  TGetV1PerpetualFollowsCurrentCopyTradeDetailParams,
  TGetV1PerpetualFollowsCurrentCopyTradeDetailResponse,
  getV1PerpetualFollowsCurrentCopyTradeDetail,
  TGetV1PerpetualFollowsHistoryCopyTradeTraderParams,
  TGetV1PerpetualFollowsHistoryCopyTradeTraderResponse,
  getV1PerpetualFollowsHistoryCopyTradeTrader,
  TGetV1PerpetualFollowsHistoryHistoryTradeParams,
  TGetV1PerpetualFollowsHistoryHistoryTradeResponse,
  getV1PerpetualFollowsHistoryHistoryTrade,
  TGetV1PerpetualFollowsHistoryHistoryTradeDataParams,
  TGetV1PerpetualFollowsHistoryHistoryTradeDataResponse,
  getV1PerpetualFollowsHistoryHistoryTradeData,
  TGetV1PerpetualFollowsIsTraderParams,
  TGetV1PerpetualFollowsIsTraderResponse,
  getV1PerpetualFollowsIsTrader,
  TGetV1PerpetualFollowsPublicTraderCollectParams,
  TGetV1PerpetualFollowsPublicTraderCollectResponse,
  getV1PerpetualFollowsPublicTraderCollect,
  TGetV1PerpetualFollowsMyLeadCopyTraderCurrentParams,
  TGetV1PerpetualFollowsMyLeadCopyTraderCurrentResponse,
  getV1PerpetualFollowsMyLeadCopyTraderCurrent,
  TGetV1PerpetualFollowsMyLeadCopyTraderHistoryParams,
  TGetV1PerpetualFollowsMyLeadCopyTraderHistoryResponse,
  getV1PerpetualFollowsMyLeadCopyTraderHistory,
  TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveParams,
  TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveResponse,
  deleteV1PerpetualFollowsMyLeadCopyTraderRemove,
  TGetV1PerpetualFollowsMyLeadDataCurrentTradeParams,
  TGetV1PerpetualFollowsMyLeadDataCurrentTradeResponse,
  getV1PerpetualFollowsMyLeadDataCurrentTrade,
  TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailParams,
  TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailResponse,
  getV1PerpetualFollowsMyLeadDataHistoryTradeDetail,
  TGetV1PerpetualFollowsMyLeadPauseParams,
  TGetV1PerpetualFollowsMyLeadPauseResponse,
  getV1PerpetualFollowsMyLeadPause,
  TGetV1PerpetualFollowsMyLeadResumeParams,
  TGetV1PerpetualFollowsMyLeadResumeResponse,
  getV1PerpetualFollowsMyLeadResume,
  TGetV1PerpetualFollowsMyTraderListParams,
  TGetV1PerpetualFollowsMyTraderListResponse,
  getV1PerpetualFollowsMyTraderList,
  TPostV1PerpetualFollowsStartCopyTradeParams,
  TPostV1PerpetualFollowsStartCopyTradeResponse,
  postV1PerpetualFollowsStartCopyTrade,
  TPutV1PerpetualFollowsStopCopyTradeParams,
  TPutV1PerpetualFollowsStopCopyTradeResponse,
  putV1PerpetualFollowsStopCopyTrade,
  TGetV1PerpetualFollowsTraderDetailParams,
  TGetV1PerpetualFollowsTraderDetailResponse,
  getV1PerpetualFollowsTraderDetail,
  TGetV1PerpetualFollowsPublicTraderListParams,
  TGetV1PerpetualFollowsPublicTraderListResponse,
  getV1PerpetualFollowsPublicTraderList,
  TPutV1PerpetualFollowsTransferInParams,
  TPutV1PerpetualFollowsTransferInResponse,
  putV1PerpetualFollowsTransferIn,
  TGetV1PerpetualFollowsPublicTraderCurrentLeadParams,
  TGetV1PerpetualFollowsPublicTraderCurrentLeadResponse,
  getV1PerpetualFollowsPublicTraderCurrentLead,
  TGetV1PerpetualFollowsPublicTraderHistoryLeadParams,
  TGetV1PerpetualFollowsPublicTraderHistoryLeadResponse,
  getV1PerpetualFollowsPublicTraderHistoryLead,
  TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderParams,
  TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderResponse,
  getV1PerpetualFollowsPublicTraderStatisticsCopyTrader,
  TPostV1PerpetualFollowsApplyForTraderParams,
  TPostV1PerpetualFollowsApplyForTraderResponse,
  postV1PerpetualFollowsApplyForTrader,
  TGetV1PerpetualFollowsPublicTraderStatisticsParams,
  TGetV1PerpetualFollowsPublicTraderStatisticsResponse,
  getV1PerpetualFollowsPublicTraderStatistics,
  TPutV1PerpetualFollowsTraderSettingParams,
  TPutV1PerpetualFollowsTraderSettingResponse,
  putV1PerpetualFollowsTraderSetting,
  TGetV1PerpetualFollowsTraderQualificationParams,
  TGetV1PerpetualFollowsTraderQualificationResponse,
  getV1PerpetualFollowsTraderQualification,
  TGetV1PerpetualFollowsCopyTradeStatisticsParams,
  TGetV1PerpetualFollowsCopyTradeStatisticsResponse,
  getV1PerpetualFollowsCopyTradeStatistics,
  TGetV1PerpetualFollowsPublicTraderContractParams,
  TGetV1PerpetualFollowsPublicTraderContractResponse,
  getV1PerpetualFollowsPublicTraderContract,
  TGetV1PerpetualFollowsPublicTraderSettingParams,
  TGetV1PerpetualFollowsPublicTraderSettingResponse,
  getV1PerpetualFollowsPublicTraderSetting,
  TPutV1PerpetualFollowsTransferOutParams,
  TPutV1PerpetualFollowsTransferOutResponse,
  putV1PerpetualFollowsTransferOut,
  TGetV1PerpetualFollowsPublicTraderStatisticsMapParams,
  TGetV1PerpetualFollowsPublicTraderStatisticsMapResponse,
  getV1PerpetualFollowsPublicTraderStatisticsMap,
  TPutV1PerpetualFollowsTraderSettingV2Params,
  TPutV1PerpetualFollowsTraderSettingV2Response,
  putV1PerpetualFollowsTraderSettingV2,
  TPostV1PerpetualFollowsOpenPrivateLeadParams,
  TPostV1PerpetualFollowsOpenPrivateLeadResponse,
  postV1PerpetualFollowsOpenPrivateLead,
  TPutV1PerpetualFollowsCheckParams,
  TPutV1PerpetualFollowsCheckResponse,
  putV1PerpetualFollowsCheck,
} from 'core/service/yapi/swap/SpecContractCopyTradeSystemV1Contreller/api'
// 合约跟单系统-V1
// 合约跟单系统---跟单合约信息
export const useGetV1PerpetualFollowsCopyTradeContractQuery = (
  params?: TGetV1PerpetualFollowsCopyTradeContractParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsCopyTradeContractResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsCopyTradeContract',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsCopyTradeContract(params),
  })
}

// 合约跟单系统--修改跟单设置、修改止赢止损
export const usePutV1PerpetualFollowsCopyTradeSettingMutation = (
  mutationOptions?: TUseMutationOptions<
    TPutV1PerpetualFollowsCopyTradeSettingResponse,
    TPutV1PerpetualFollowsCopyTradeSettingParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsCopyTradeSetting', 'Put'],
    mutationFn: (params?: TPutV1PerpetualFollowsCopyTradeSettingParams) =>
      putV1PerpetualFollowsCopyTradeSetting(params),
  })
}

// 合约跟单系统--当前跟单汇总
export const useGetV1PerpetualFollowsCurrentCopyTradeCollectQuery = (
  params?: TGetV1PerpetualFollowsCurrentCopyTradeCollectParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsCurrentCopyTradeCollectResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsCurrentCopyTradeCollect',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsCurrentCopyTradeCollect(params),
  })
}

// 合约跟单系统--当前跟单仓位详情
export const useGetV1PerpetualFollowsCurrentCopyTradeDetailQuery = (
  params?: TGetV1PerpetualFollowsCurrentCopyTradeDetailParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsCurrentCopyTradeDetailResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsCurrentCopyTradeDetail',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsCurrentCopyTradeDetail(params),
  })
}

// 合约跟单系统--历史跟单交易员
export const useGetV1PerpetualFollowsHistoryCopyTradeTraderQuery = (
  params?: TGetV1PerpetualFollowsHistoryCopyTradeTraderParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsHistoryCopyTradeTraderResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsHistoryCopyTradeTrader',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsHistoryCopyTradeTrader(params),
  })
}

// 合约跟单系统--历史跟单历史委托
export const useGetV1PerpetualFollowsHistoryHistoryTradeQuery = (
  params?: TGetV1PerpetualFollowsHistoryHistoryTradeParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsHistoryHistoryTradeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsHistoryHistoryTrade',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsHistoryHistoryTrade(params),
  })
}

// 合约跟单系统--历史跟单订单数据
export const useGetV1PerpetualFollowsHistoryHistoryTradeDataQuery = (
  params?: TGetV1PerpetualFollowsHistoryHistoryTradeDataParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsHistoryHistoryTradeDataResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsHistoryHistoryTradeData',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsHistoryHistoryTradeData(params),
  })
}

// 合约跟单系统---是否是交易员
export const useGetV1PerpetualFollowsIsTraderQuery = (
  params?: TGetV1PerpetualFollowsIsTraderParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsIsTraderResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsIsTrader',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsIsTrader(params),
    select: (res) => res.data.data,
  })
}

// 合约跟单系统--交易员带单汇总
export const useGetV1PerpetualFollowsPublicTraderCollectQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderCollectParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderCollectResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderCollect',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderCollect(params),
    select: (res) => res.data.data,
  })
}

// 合约跟单系统--我的带单数据--当前跟单
export const useGetV1PerpetualFollowsMyLeadCopyTraderCurrentQuery = (
  params?: TGetV1PerpetualFollowsMyLeadCopyTraderCurrentParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsMyLeadCopyTraderCurrentResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsMyLeadCopyTraderCurrent',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsMyLeadCopyTraderCurrent(params),
  })
}

// 合约跟单系统--我的带单数据--历史跟单
export const useGetV1PerpetualFollowsMyLeadCopyTraderHistoryQuery = (
  params?: TGetV1PerpetualFollowsMyLeadCopyTraderHistoryParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsMyLeadCopyTraderHistoryResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsMyLeadCopyTraderHistory',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsMyLeadCopyTraderHistory(params),
  })
}

// 合约跟单系统--我的带单数据--移除当前跟单用户
export const useDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveMutation = (
  mutationOptions?: TUseMutationOptions<
    TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveResponse,
    TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsMyLeadCopyTraderRemove', 'Delete'],
    mutationFn: (params?: TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveParams) =>
      deleteV1PerpetualFollowsMyLeadCopyTraderRemove(params),
  })
}

// 合约跟单系统--我的带单数据--当前带单
export const useGetV1PerpetualFollowsMyLeadDataCurrentTradeQuery = (
  params?: TGetV1PerpetualFollowsMyLeadDataCurrentTradeParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsMyLeadDataCurrentTradeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsMyLeadDataCurrentTrade',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsMyLeadDataCurrentTrade(params),
  })
}

// 合约跟单系统--我的带单数据--历史带单
export const useGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailQuery = (
  params?: TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsMyLeadDataHistoryTradeDetail',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsMyLeadDataHistoryTradeDetail(params),
  })
}

// 合约跟单系统--暂停带单
export const useGetV1PerpetualFollowsMyLeadPauseQuery = (
  params?: TGetV1PerpetualFollowsMyLeadPauseParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsMyLeadPauseResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsMyLeadPause',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsMyLeadPause(params),
  })
}

// 合约跟单系统--恢复带单
export const useGetV1PerpetualFollowsMyLeadResumeQuery = (
  params?: TGetV1PerpetualFollowsMyLeadResumeParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsMyLeadResumeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsMyLeadResume',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsMyLeadResume(params),
  })
}

// 合约跟单系统--我的交易员
export const useGetV1PerpetualFollowsMyTraderListQuery = (
  params?: TGetV1PerpetualFollowsMyTraderListParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsMyTraderListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsMyTraderList',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsMyTraderList(params),
  })
}

// 合约跟单系统--开始跟单（跟单设置）
export const usePostV1PerpetualFollowsStartCopyTradeMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostV1PerpetualFollowsStartCopyTradeResponse,
    TPostV1PerpetualFollowsStartCopyTradeParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsStartCopyTrade', 'Post'],
    mutationFn: (params?: TPostV1PerpetualFollowsStartCopyTradeParams) => postV1PerpetualFollowsStartCopyTrade(params),
  })
}

// 合约跟单系统--结束跟单
export const usePutV1PerpetualFollowsStopCopyTradeMutation = (
  mutationOptions?: TUseMutationOptions<
    TPutV1PerpetualFollowsStopCopyTradeResponse,
    TPutV1PerpetualFollowsStopCopyTradeParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsStopCopyTrade', 'Put'],
    mutationFn: (params?: TPutV1PerpetualFollowsStopCopyTradeParams) => putV1PerpetualFollowsStopCopyTrade(params),
  })
}

// 合约跟单系统--交易员详情
export const useGetV1PerpetualFollowsTraderDetailQuery = (
  params?: TGetV1PerpetualFollowsTraderDetailParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsTraderDetailResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsTraderDetail',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsTraderDetail(params),
  })
}

// 合约跟单系统--交易员列表
export const useGetV1PerpetualFollowsPublicTraderListQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderListParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderList',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderList(params),
  })
}

// 合约跟单系统--转入
export const usePutV1PerpetualFollowsTransferInMutation = (
  mutationOptions?: TUseMutationOptions<
    TPutV1PerpetualFollowsTransferInResponse,
    TPutV1PerpetualFollowsTransferInParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsTransferIn', 'Put'],
    mutationFn: (params?: TPutV1PerpetualFollowsTransferInParams) => putV1PerpetualFollowsTransferIn(params),
  })
}

// 合约跟单系统--交易员当前带单
export const useGetV1PerpetualFollowsPublicTraderCurrentLeadQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderCurrentLeadParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderCurrentLeadResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderCurrentLead',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderCurrentLead(params),
  })
}

// 合约跟单系统--交易员历史带单
export const useGetV1PerpetualFollowsPublicTraderHistoryLeadQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderHistoryLeadParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderHistoryLeadResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderHistoryLead',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderHistoryLead(params),
  })
}

// 合约跟单系统--交易员统计跟单用户
export const useGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderStatisticsCopyTrader',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderStatisticsCopyTrader(params),
  })
}

// 合约跟单系统---申请带单
export const usePostV1PerpetualFollowsApplyForTraderMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostV1PerpetualFollowsApplyForTraderResponse,
    TPostV1PerpetualFollowsApplyForTraderParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsApplyForTrader', 'Post'],
    mutationFn: (params?: TPostV1PerpetualFollowsApplyForTraderParams) => postV1PerpetualFollowsApplyForTrader(params),
  })
}

// 合约跟单系统--交易员统计
export const useGetV1PerpetualFollowsPublicTraderStatisticsQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderStatisticsParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderStatisticsResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderStatistics',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderStatistics(params),
  })
}

// 合约跟单系统---带单员设置
export const usePutV1PerpetualFollowsTraderSettingMutation = (
  mutationOptions?: TUseMutationOptions<
    TPutV1PerpetualFollowsTraderSettingResponse,
    TPutV1PerpetualFollowsTraderSettingParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsTraderSetting', 'Put'],
    mutationFn: (params?: TPutV1PerpetualFollowsTraderSettingParams) => putV1PerpetualFollowsTraderSetting(params),
  })
}

// 合约跟单系统---用户是否符合交易员资质
export const useGetV1PerpetualFollowsTraderQualificationQuery = (
  params?: TGetV1PerpetualFollowsTraderQualificationParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsTraderQualificationResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsTraderQualification',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsTraderQualification(params),
    select: (res) => res?.data?.data,
  })
}

// 合约跟单系统---历史跟单统计
export const useGetV1PerpetualFollowsCopyTradeStatisticsQuery = (
  params?: TGetV1PerpetualFollowsCopyTradeStatisticsParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsCopyTradeStatisticsResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsCopyTradeStatistics',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsCopyTradeStatistics(params),
  })
}

// 合约跟单系统---带单员合约信息
export const useGetV1PerpetualFollowsPublicTraderContractQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderContractParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderContractResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderContract',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderContract(params),
    select: (res) => res?.data?.data,
  })
}

// 合约跟单系统---带单员设置
export const useGetV1PerpetualFollowsPublicTraderSettingQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderSettingParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderSettingResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderSetting',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderSetting(params),
  })
}

// 合约跟单系统--转出
export const usePutV1PerpetualFollowsTransferOutMutation = (
  mutationOptions?: TUseMutationOptions<
    TPutV1PerpetualFollowsTransferOutResponse,
    TPutV1PerpetualFollowsTransferOutParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsTransferOut', 'Put'],
    mutationFn: (params?: TPutV1PerpetualFollowsTransferOutParams) => putV1PerpetualFollowsTransferOut(params),
  })
}

// 合约跟单系统--交易员总统计
export const useGetV1PerpetualFollowsPublicTraderStatisticsMapQuery = (
  params?: TGetV1PerpetualFollowsPublicTraderStatisticsMapParams,
  options?: TUseQueryOptions<TGetV1PerpetualFollowsPublicTraderStatisticsMapResponse>
) => {
  return useQuery({
    ...options,
    queryKey: [
      'SpecContractCopyTradeSystemV1Contreller',
      'V1PerpetualFollowsPublicTraderStatisticsMap',
      'GET',
      ...Object.values(params || {}),
    ],
    queryFn: () => getV1PerpetualFollowsPublicTraderStatisticsMap(params),
  })
}

// 合约跟单系统---带单员设置V2
export const usePutV1PerpetualFollowsTraderSettingV2Mutation = (
  mutationOptions?: TUseMutationOptions<
    TPutV1PerpetualFollowsTraderSettingV2Response,
    TPutV1PerpetualFollowsTraderSettingV2Params
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsTraderSettingV2', 'Put'],
    mutationFn: (params?: TPutV1PerpetualFollowsTraderSettingV2Params) => putV1PerpetualFollowsTraderSettingV2(params),
  })
}

// 开启私域带单或者更新私域带单邀请码
export const usePostV1PerpetualFollowsOpenPrivateLeadMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostV1PerpetualFollowsOpenPrivateLeadResponse,
    TPostV1PerpetualFollowsOpenPrivateLeadParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsOpenPrivateLead', 'Post'],
    mutationFn: (params?: TPostV1PerpetualFollowsOpenPrivateLeadParams) =>
      postV1PerpetualFollowsOpenPrivateLead(params),
  })
}

// 合约跟单系统--跟单验证
export const usePutV1PerpetualFollowsCheckMutation = (
  mutationOptions?: TUseMutationOptions<TPutV1PerpetualFollowsCheckResponse, TPutV1PerpetualFollowsCheckParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['SpecContractCopyTradeSystemV1Contreller', 'V1PerpetualFollowsCheck', 'Put'],
    mutationFn: (params?: TPutV1PerpetualFollowsCheckParams) => putV1PerpetualFollowsCheck(params),
  })
}
